import { useNavigate } from "react-router-dom";
import { ListMusic, SkipForward, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { playlistKey, startPlaylistItem } from "@/pages/teacher/PlaylistsPage";

export const PlaylistBar = ({ code, finished }) => {
  const navigate = useNavigate();
  let run = null;
  try { run = JSON.parse(localStorage.getItem(playlistKey) || "null"); } catch { run = null; }
  if (!run || run.code !== code) return null;
  const hasNext = run.index + 1 < run.total;
  const next = () => startPlaylistItem(navigate, { id: run.id, title: run.title, items: { length: run.total } }, run.index + 1);
  const stop = () => { localStorage.removeItem(playlistKey); navigate("/ogretmen/listeler"); };
  return (
    <div className={`panel p-3 flex flex-wrap items-center gap-3 ${finished ? "border-[#FACC15]" : ""}`} data-testid="playlist-bar">
      <ListMusic className="h-5 w-5 text-[#FACC15]" />
      <span className="font-semibold">{run.title}</span>
      <span className="text-sm text-slate-400" data-testid="playlist-bar-position">{run.index + 1} / {run.total}</span>
      <div className="ml-auto flex gap-2">
        {hasNext && <Button size="sm" onClick={next} className={finished ? "font-bold anim-pop" : ""} data-testid="playlist-next"><SkipForward className="h-4 w-4 mr-1" />Sıradakini başlat</Button>}
        <Button size="sm" variant="ghost" onClick={stop} data-testid="playlist-stop"><X className="h-4 w-4 mr-1" />{hasNext ? "Listeyi bitir" : "Liste bitti"}</Button>
      </div>
    </div>
  );
};
